export const GlobalFeatureFlagConstants = {
    MIReportsAdmin: 'MIReportsAdmin',
    CurrentDateComplete_53966: 'CurrentDateComplete_53966',
    AuditTrailDocumentFix_68802: 'AuditTrailDocumentFix_68802',
    DocumentEmailMergeFields_73519: 'DocumentEmailMergeFields_73519',
    TimePickerResetAndFormat_77825: 'TimePickerResetAndFormat_77825',
}
